import { useEffect, useRef, useState } from "react";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import s from "../PatientPortal/clientApp.module.css";

const SWIPE_THRESHOLD = 48;

export default function ClubPhotoSlider({
  photos,
  accentColor,
  emptyClassName,
  emptyStyle,
  galleryClassName = "",
  hideDots = false,
  hideFade = false,
}) {
  const [index, setIndex] = useState(0);
  const touchRef = useRef({ x: 0, y: 0 });
  const slides = photos?.length ? photos : [];

  useEffect(() => {
    setIndex(0);
  }, [photos]);

  const go = (dir) => {
    setIndex((i) => Math.max(0, Math.min(slides.length - 1, i + dir)));
  };

  const onTouchStart = (e) => {
    const t = e.touches[0];
    touchRef.current = { x: t.clientX, y: t.clientY };
  };

  const onTouchEnd = (e) => {
    if (slides.length < 2) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - touchRef.current.x;
    const dy = t.clientY - touchRef.current.y;
    if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
    go(dx < 0 ? 1 : -1);
  };

  if (!slides.length) {
    const hasCoverImage = Boolean(emptyStyle?.backgroundImage);
    const hasSolidFill = Boolean(
      emptyStyle?.backgroundColor || (!hasCoverImage && emptyStyle?.background),
    );
    const showHeroFill = hasCoverImage || hasSolidFill;
    return (
      <div
        className={`${emptyClassName || s.clubGalleryEmpty} ${galleryClassName}`.trim()}
        style={emptyStyle}
        aria-hidden={showHeroFill ? "true" : undefined}
      >
        {showHeroFill ? (
          hasCoverImage && !hideFade ? (
            <div className={s.clubGalleryFade} aria-hidden />
          ) : null
        ) : (
          <div className={s.clubGalleryEmptyInner}>
            <span className={s.clubGalleryEmptyGlyph}>🏟️</span>
            <span>Фото клуба скоро появятся</span>
          </div>
        )}
      </div>
    );
  }

  const dotStyle =
    accentColor && accentColor !== "var(--ca-accent)"
      ? { background: accentColor }
      : undefined;

  return (
    <div
      className={`${s.clubGallery} ${galleryClassName}`.trim()}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <div
        className={s.clubGalleryTrack}
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {slides.map((url) => (
          <div
            key={url}
            className={s.clubGallerySlide}
            style={{ backgroundImage: `url(${mediaUrl(url)})` }}
          />
        ))}
      </div>
      {hideFade ? null : <div className={s.clubGalleryFade} aria-hidden />}
      {!hideDots && slides.length > 1 ? (
        <div className={s.clubGalleryDots} aria-hidden>
          {slides.map((url, i) => (
            <button
              key={url}
              type="button"
              className={i === index ? s.clubGalleryDotOn : s.clubGalleryDot}
              style={i === index ? dotStyle : undefined}
              onClick={() => setIndex(i)}
              aria-label={`Фото ${i + 1}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
